import React, { useState } from "react"
import { navigate } from "gatsby"
import { FormikWizard } from "formik-wizard"
import { useToasts } from "react-toast-notifications"
import { PaystackButton } from "react-paystack"
import { sendNotification, notifyUser } from "../../Helpers"

import TinIcon from "../../../images/business/new-tin.svg"
import steps from "./steps"
import TinApplicationWrapper from "./TinApplicationWrapper"
import Summary from "./views/Summary"
import BusinessTitleCard from "../BusinessCardTitle"

const StartApplication = () => {
  const [data, setData] = useState({})
  const { addToast } = useToasts()
  const [showSummary, setShowSummary] = useState(false)
  const [loading, setLoading] = useState(false)
  const [config, setConfig] = useState({})

  // Submit Data
  const handleSubmit = (values) => {
    setShowSummary(true)

    setData({
      account_number:
        typeof window !== `undefined`
          ? localStorage.getItem("nuban_id_24b854967")
          : null,
      company_name: values.business_info.company_name,
      proprietor_name: values.business_info.proprietor_name,
      rc_number: values.business_info.rc_number,
      registration_date: values.business_info.registration_date,
      email: values.business_info.email,
      phone: values.business_info.phone,
      business_address: values.other_info.business_address,
      country: values.other_info.country,
      state: values.other_info.state,
      city: values.other_info.city,
      certificate_of_registration:
        values.additional_documents.certificate_of_registration,
      certificate_of_registration_name:
        values.additional_documents.certificate_of_registration_name,
    })
  }

  const onClose = () => {
    console.log("closed")
  }

  const createRecord = async (fields) => {
    await fetch(`${process.env.DIY_BASE_URL}/api/order/v1/TinVat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Token ${localStorage.getItem("dd_token")}`,
      },
      body: JSON.stringify(fields),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response)
      })
      .catch((error) => {
        console.error(error)
        return []
      })

    sendNotification({
      to: "indy@sparkle.ng",
      cc: "hello@diylaw.ng",
      from: "indy@sparkle.ng",
      subject: `New Tin Application Registration By ${fields.company_name}`,
      templateId: "d-931d7904508c488296cbcaf2cb60b93b",
      dynamicTemplateData: {
        subject: `New Tin Application Registration By ${fields.company_name}`,
        name: fields.company_name,
        email: fields.email,
        service: "New Tin Application",
      },
    })
  }
  const onSuccess = async (reference) => {
    console.log("heree")
    await createRecord({
      company_name: data.company_name,
      rc_number: data.rc_number,
      proprietor_name: data.proprietor_name,
      registration_date: data.registration_date,
      email: data.email,
      phone: data.phone,
      business_address: data.business_address,
      country: parseInt(data.country),
      state: data.state,
      city: data.city,
      file1: {
        name: data.certificate_of_registration,
      },
      file2: {
        name: data.certificate_of_registration,
      },
    })
    addToast("Application Successful", {
      appearance: "success",
      placement: "top-center",
      autoDismiss: true,
    })

    notifyUser({
      to: data.email,
      from: "indy@sparkle.ng",
      subject: `Tin Application Registration At Sparkle`,
      templateId: "d-f70dd4b4ed1a47b794a4ef3b66b5ea5c",
      dynamicTemplateData: {
        subject: `Tin Application Registration At Sparkle`,
        name: data.company_name,
        service: "New Tin Application",
      },
    })

    localStorage.clear()
    setLoading(false)

    setTimeout(function () {
      navigate("/business-support/get-started")
    }, 2000)
  }

  const initPayment = async () => {
    var min = 10000000000000
    var max = 99999999999999

    var payoutRef = Math.round(Math.random() * (max - min) + min).toString()

    let payload = {
      reference: payoutRef,
      email: data.email,
      amount: 350000,
      metadata: {
        custom_fields: [
          {
            display_name: "Business Support Service",
            variable_name: "Business Support Service",
            value: "TinApplication",
          },
        ],
      },
      publicKey: process.env.PAYSTACK_KEY,
    }

    await setConfig({ ...config, ...payload })
    document.querySelector("button.paystack").click()
  }
  const componentProps = {
    email: data.email,
    amount: 350000,
    metadata: {
      custom_fields: [
        {
          display_name: "Business Support Service",
          variable_name: "Business Support Service",
          value: "TinApplication",
        },
      ],
    },
    text: "Pay with Card",
    publicKey: process.env.PAYSTACK_KEY,
    onSuccess: (reference) => onSuccess(reference),
    onClose: onClose,
  }

  return (
    <div>
      <div className={!showSummary ? "container" : "container d-none"}>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <BusinessTitleCard
              title="New TIN"
              icon={TinIcon}
              subtitle="Apply for a new Tax identification number (TIN)."
            />
            <div className="business-suport-card my-lg-5 waitlist__form ">
              <FormikWizard
                steps={steps}
                onSubmit={handleSubmit}
                render={TinApplicationWrapper}
              />
            </div>
          </div>
        </div>
      </div>

      <PaystackButton {...componentProps} className="btn paystack d-none" />

      {showSummary && (
        <Summary
          data={data}
          payFee={initPayment}
          setShowSummary={setShowSummary}
          loadingStatus={loading}
        />
      )}
    </div>
  )
}

export default StartApplication
